export const namespaces = [
  'catalog',
  'companyOnboarding',
  'invoiceDetails',
  'invoices',
  'newInvoice',
  'platform',
  'receivables',
  'settings',
  'shared',
] as const
